import { utcTimeToLocal } from './tournamentCardView'

// Static rules copy per tournament type — there is no BE field for this (same
// as defenderV2: no rules endpoint exists, just hardcoded English per type).
// Ported here as plain data (no fake loading state) so it renders instantly.
const RULES_BY_TYPE = {
  NUMBER_OF_BETS: [
    'The leaderboard is ranked based on the total number of bets placed by a user during the tournament.',
    'Only bets placed within the tournament time window are considered.',
    'All eligible bets placed during this time range are tracked and counted toward the leaderboard.',
    "At the end of the tournament, rewards are distributed based on the user's final leaderboard position.",
    'Reward details for each rank can be viewed in the Prizes tab.',
    'Rewards will be credited within 1 hour of the tournament end time.',
    'Freebets awarded through this tournament can be used to place bets via the Freebets section.',
  ],
  HIGHEST_BETS: [
    'The leaderboard is ranked based on the total stake value placed by a user during the tournament period.',
    'Only bets placed within the tournament time window are considered.',
    'All eligible bets placed during this time range are tracked and counted toward the leaderboard.',
    "At the end of the tournament, rewards are distributed based on the user's final leaderboard position.",
    'Reward details for each rank can be viewed in the Prizes tab.',
    'Rewards will be credited within 1 hour of the tournament end time.',
    'Freebets awarded through this tournament can be used to place bets via the Freebets section.',
  ],
}

// Rules text references the tournament's own time window, so it's built per
// tournament rather than stored as a flat string.
export const getTournamentRules = (type, { timeFrom, timeTo } = {}) => {
  const rules = RULES_BY_TYPE[type]
  if (!rules) return []

  const window = timeFrom && timeTo ? ` [ ${utcTimeToLocal(timeFrom)} - ${utcTimeToLocal(timeTo)} ]` : ''
  return rules.map((rule) =>
    rule === 'Only bets placed within the tournament time window are considered.'
      ? `Only bets placed within the tournament time window${window} are considered.`
      : rule
  )
}
